/** `chat` namespace — Swedish (source of truth). */
const chat = {
  composer: {
    placeholder: 'Skriv ett meddelande…',
    placeholderNew: 'Jobba med HUB',
    connectingVoice: 'Ansluter mikrofon…',
    listening: 'Lyssnar…',
    dictationLimit: 'Dikteringen stoppades — maxlängden är nådd.',
    dictationUnavailable: 'Diktering är inte tillgänglig.',
    dictationFailed: 'Dikteringen avbröts. Försök igen.',
    micDenied: 'Mikrofonen är blockerad — tillåt den i webbläsaren.',
    placeholderBusy: 'Skriv – skickas när svaret är klart…',
    attachFile: 'Bifoga fil',
    attach: 'Bifoga',
    addAttachment: 'Lägg till bilaga',
    removeAttachment: 'Ta bort {{name}}',
    addToChat: 'Lägg till i chatten',
    selections_one: '{{count}} markering',
    selections_other: '{{count}} markeringar',
    selectionsTitle: 'Markerad text som skickas med',
    removeSelection: 'Ta bort markeringen',
    selectionTruncated: 'Kortad till {{max}} tecken',
    sendMessage: 'Skicka meddelande',
    sendWithShortcut: 'Skicka ({{shortcut}})',
    stopGenerating: 'Stoppa genereringen',
    stopFailed: 'Svaret kunde inte stoppas. Försök igen.',
    stopConfirmTitle: 'Agenten arbetar fortfarande',
    stopConfirmBody:
      'Agenten arbetar fortfarande — vill du verkligen stoppa? Svaret som håller på att skrivas går förlorat.',
    stopConfirmKeepWaiting: 'Fortsätt vänta',
    stopConfirmStop: 'Stoppa ändå',
    startVoice: 'Starta röstinmatning',
    stopRecording: 'Stoppa inspelningen',
    context: 'Kontext',
    contextUsage: 'Kontextanvändning',
    contextSystem: 'System',
    contextTools: 'Verktyg',
    contextMessages: 'Meddelanden',
    contextTotal: 'Totalt',
    invalidResponse: 'Ogiltigt svar',
    uploadFailed: 'Uppladdning misslyckades ({{status}})',
    networkError: 'Nätverksfel',
    error: 'Fel',
    projectDocument: 'Projektdokument',
    file: 'Fil',
  },
  uiBlocks: {
    filter: 'Filtrera',
    rows_one: '{{count}} rad',
    rows_other: '{{count}} rader',
    rowsFiltered: '{{shown}} av {{count}} rader',
    noRows: 'Inga rader matchar',
    exportCsv: 'Exportera CSV',
    csvFilename: 'tabell',
    showAsTable: 'Visa som tabell',
    showAsChart: 'Visa som diagram',
    other: 'Övrigt',
    chartSummary: '{{kind}}: {{series}}. {{count}} kategorier, från {{min}} till {{max}}.',
    kindBar: 'Stapeldiagram',
    kindLine: 'Linjediagram',
    kindPie: 'Cirkeldiagram',
    couldNotRender: 'Blocket kunde inte visas.',
    loading: 'Laddar…',
  },
  attachmentPicker: {
    uploadFromComputer: 'Ladda upp från dator',
    chooseDocuments: 'Välj dokument',
    back: 'Tillbaka',
  },
  documentPicker: {
    searchPlaceholder: 'Sök dokument...',
    all: 'Alla',
    empty: 'Inga dokument hittades',
    noneSelected: 'Inga valda',
    selected_one: '{{count}} vald',
    selected_other: '{{count}} valda',
    add: 'Lägg till',
  },
  prompts: {
    suggested: 'Föreslagen',
    preparation: 'Vilka moment ska ingå i arbetsberedningen för lättväggar?',
    risk: 'Vilka arbetsmiljörisker finns vid montage av lättväggar med stålreglar?',
    experience: 'Vilka problem uppstod vid montering av lättväggarna i trapphus B?',
  },
  thread: {
    syncing: 'Synkar chatt...',
    loadOlder: 'Ladda äldre meddelanden',
    loading: 'Laddar...',
    typing: '{{names}} skriver…',
    openWorkspace: 'Öppna arbetsytan',
    disclaimer: 'HUB är AI och kan göra fel — dubbelkolla viktiga uppgifter.',
    jumpToLatest: 'Hoppa till senaste',
    jumpToLatestNew: 'Nytt innehåll nedanför — hoppa till senaste',
  },
  queue: {
    running: 'pågår',
    queued_one: '{{count}} i kö',
    queued_other: '{{count}} i kö',
    sentWhenDone: 'skickas när svaret är klart',
    remove: 'Ta bort "{{text}}" från kön',
  },
  message: {
    deleteAria: 'Ta bort meddelandet',
    deletedByUser: 'Borttaget av användare',
    deleteTitle: 'Ta bort meddelandet?',
    deleteDescription:
      'Meddelandet visas fortfarande som "Borttaget av användare" för alla i chatten. Du kan inte ångra det här.',
    cancel: 'Avbryt',
    delete: 'Ta bort',
    attachmentDocument: 'dokument',
    quotedSelection: 'Markerad text',
    attachmentFile: 'fil',
    userFallback: 'Användare',
  },
  email: {
    open: 'Öppna e-postmeddelandet i inkorgen',
    noSubject: '(inget ämne)',
    attachments_one: '{{count}} bilaga',
    attachments_other: '{{count}} bilagor',
    deleted: 'E-postmeddelandet är borttaget',
  },
  actions: {
    play: 'Läs upp',
    stopPlayback: 'Stoppa uppläsning',
    pausePlayback: 'Pausa uppläsning',
    resumePlayback: 'Fortsätt uppläsning',
    copy: 'Kopiera svaret',
    copied: 'Svaret kopierat',
    helpful: 'Markera svaret som hjälpsamt',
    unhelpful: 'Markera svaret som inte hjälpsamt',
    more: 'Fler åtgärder',
  },
  usage: {
    more: 'Mer om svaret',
    title: 'Användning',
    mode: 'Läge',
    tokensIn: 'Tokens in',
    tokensOut: 'Tokens ut',
    reasoning: 'Resonemang',
    cache: 'Varav cache',
    total: 'Totalt',
    modelCalls: 'Modellanrop',
    credits: 'Krediter',
    creditsBreakdown: 'LLM {{llm}} · verktyg {{tools}}',
    none: 'Ingen användningsdata för det här svaret',
    words: 'Ord',
    toolCalls: 'Verktygsanrop',
    duration: 'Svarstid',
    durationSeconds: '{{seconds}} s',
    durationMinutes: '{{minutes}} min {{seconds}} s',
    showRaw: 'Visa rådata (dev)',
  },
  status: {
    queued: 'Väntar på agenten',
    reasoning: 'Resonerar',
    toolCalling: 'Använder verktyg',
    responding: 'Skriver svar',
    thinking: 'Tänker',
    takingLonger: 'Tar längre tid än vanligt',
  },
  errors: {
    ttsFailed: 'Uppläsningen misslyckades.',
    provider_capability: 'Modelleverantören avvisade förfrågan',
    provider_transient: 'Modelltjänsten hade ett tillfälligt problem',
    hard_error: 'Det här svaret kunde inte genereras',
    empty_reply: 'Agenten avslutade utan att svara',
    unknown: 'Svaret gick inte igenom',
    interrupted: 'Svaret avbröts innan allt var klart',
    stopped: 'Stoppat – svaret är inte komplett',
    stoppedEmpty: 'Stoppat innan svaret hann börja',
    interruptedHint:
      'Agenten slutade svara mitt i arbetet — steg som skulle utföras efter det (t.ex. att uppdatera ett dokument) blev troligen inte gjorda. Försök igen om du vill.',
    retryableHint: 'Försök igen — det brukar lösa sig på andra försöket.',
    nonRetryableHint:
      'Det är osannolikt att ett nytt försök lyckas — prova att formulera om eller korta ner frågan.',
    retrying: 'Försöker igen',
    retry: 'Försök igen',
    skip: 'Hoppa över',
    toolFailed: 'Verktyget misslyckades',
  },
  reasoning: {
    thinking: 'Tänker',
    done: 'Resonerat ({{seconds}}s)',
    label: 'Resonemang',
  },
  steps: {
    usingTools: 'Använder verktyg ({{done}}/{{total}})',
    tools: 'Verktyg ({{total}})',
    noParams: 'Inga parametrar',
    done: 'Klart',
    request: 'Anrop',
    result: 'Resultat',
    copied: 'Kopierat',
    copyJson: 'Kopiera {{section}} som JSON',
  },
  tools: {
    /** Board wwfu: a project plugin (remote MCP) tool. */
    mcp: { label: '{{server}} · {{tool}}', activeLabel: '{{server}} · {{tool}}…' },
    browserNavigate: {
      label: 'Öppnade sida i webbläsaren',
      activeLabel: 'Öppnar sida i webbläsaren',
    },
    browserRead: { label: 'Läste webbsidan', activeLabel: 'Läser webbsidan' },
    browserClick: { label: 'Klickade i webbläsaren', activeLabel: 'Klickar i webbläsaren' },
    browserType: { label: 'Skrev i webbläsaren', activeLabel: 'Skriver i webbläsaren' },
    browserPress: {
      label: 'Tryckte tangent i webbläsaren',
      activeLabel: 'Trycker tangent i webbläsaren',
    },
    browserScroll: { label: 'Skrollade webbsidan', activeLabel: 'Skrollar webbsidan' },
    browserHandToUser: {
      label: 'Lämnade över webbläsaren till dig',
      activeLabel: 'Väntar på dig i webbläsaren',
    },
    browserClose: { label: 'Stängde webbläsaren', activeLabel: 'Stänger webbläsaren' },
    vectorQueryTool: { label: 'Sökte i dokument', activeLabel: 'Söker i dokument' },
    saveProjectProfile: {
      label: 'Sparade projektinställningarna',
      activeLabel: 'Sparar projektinställningarna',
    },
    archiveOnboardingChat: { label: 'Arkiverade chatten', activeLabel: 'Arkiverar chatten' },
    rememberFact: { label: 'Sparade i projektminnet', activeLabel: 'Sparar i projektminnet' },
    recallProjectMemory: { label: 'Sökte i projektminnet', activeLabel: 'Söker i projektminnet' },
    forgetMemory: { label: 'Tog bort ur projektminnet', activeLabel: 'Tar bort ur projektminnet' },
    listChats: { label: 'Listade chattar', activeLabel: 'Listar chattar' },
    readChat: { label: 'Läste chatt', activeLabel: 'Läser chatt' },
    listTasks: { label: 'Listade uppgifter', activeLabel: 'Listar uppgifter' },
    listMembers: {
      label: 'Kontrollerade projektmedlemmar',
      activeLabel: 'Kontrollerar projektmedlemmar',
    },
    listDocuments: { label: 'Letade dokument', activeLabel: 'Letar dokument' },
    createTask: { label: 'Skapade uppgift', activeLabel: 'Skapar uppgift' },
    updateTask: { label: 'Uppdaterade uppgift', activeLabel: 'Uppdaterar uppgift' },
    readDocument: { label: 'Läste dokument', activeLabel: 'Läser dokument' },
    createDocument: { label: 'Skapade dokument', activeLabel: 'Skapar dokument' },
    updateDocument: { label: 'Uppdaterade dokument', activeLabel: 'Uppdaterar dokument' },
    updateBlocks: { label: 'Ändrade i dokument', activeLabel: 'Ändrar i dokument' },
    replaceDocument: { label: 'Skrev om dokument', activeLabel: 'Skriver om dokument' },
    web_search: { label: 'Sökte på webben', activeLabel: 'Söker på webben' },
    readSpreadsheetCsv: { label: 'Kontrollerade data', activeLabel: 'Kontrollerar data' },
    viewImage: { label: 'Tittade på bild igen', activeLabel: 'Tittar på bild igen' },
    listInboxEmails: {
      label: 'Listade e-post i inkorgen',
      activeLabel: 'Listar e-post i inkorgen',
    },
    readInboxEmail: { label: 'Läste e-post', activeLabel: 'Läser e-post' },
    readEmailAttachment: { label: 'Läste bilaga', activeLabel: 'Läser bilaga' },
    saveEmailAttachment: {
      label: 'Sparade bilaga i Dokument',
      activeLabel: 'Sparar bilaga i Dokument',
    },
    replyToEmail: { label: 'Svarade på e-post', activeLabel: 'Svarar på e-post' },
    archiveInboxEmail: { label: 'Arkiverade e-post', activeLabel: 'Arkiverar e-post' },
    args: {
      query: 'Fråga',
      title: 'Titel',
      documentId: 'Dokument',
      taskId: 'Uppgift',
      content: 'Innehåll',
      description: 'Beskrivning',
      status: 'Status',
      columnName: 'Kolumn',
      priority: 'Prioritet',
      assigneeId: 'Tilldelad',
      dueDate: 'Förfaller',
      tags: 'Taggar',
      limit: 'Max antal',
    },
    result: {
      waiting: 'Väntar på svar…',
      done: 'Klart',
      words_one: '{{count}} ord',
      words_other: '{{count}} ord',
      chars: '{{count}} tecken',
      updated: 'uppdaterad {{date}}',
      created: 'skapad {{date}}',
      createdDocument: 'Skapade {{title}}',
      updatedDocument: 'Uppdaterade {{title}}',
      createdTask: 'Skapade "{{title}}"',
      updatedTask: 'Uppdaterade "{{title}}"',
      csvPrefix: 'CSV · ',
      responseWith: 'Svar med {{keys}}',
      count: {
        tasks_one: '{{count}} uppgift',
        tasks_other: '{{count}} uppgifter',
        documents_one: '{{count}} dokument',
        documents_other: '{{count}} dokument',
        members_one: '{{count}} medlem',
        members_other: '{{count}} medlemmar',
        hits_one: '{{count}} träff',
        hits_other: '{{count}} träffar',
        results_one: '{{count}} resultat',
        results_other: '{{count}} resultat',
        rows_one: '{{count}} rad',
        rows_other: '{{count}} rader',
        items_one: '{{count}} post',
        items_other: '{{count}} poster',
      },
    },
  },
  artifacts: {
    task: 'Uppgift',
    newTask: 'Ny uppgift',
    newDocument: 'Nytt dokument',
    document: 'Dokument',
    failed: 'misslyckades',
    taskCreated: 'skapad',
    taskUpdated: 'uppdaterad',
    documentCreated: 'skapat',
    documentUpdated: 'uppdaterat',
    columns: {
      todo: 'Att göra',
      inProgress: 'Pågår',
      done: 'Klart',
      blocked: 'Blockerad',
    },
    writing: 'Skriver',
    words: '{{count}} ord',
  },
  mode: {
    label: 'Läge',
    normal: 'Normal',
    high: 'High',
    max: 'Max',
    maxWarning: 'I Max-läge förbrukas krediter snabbare.',
  },
  lightbox: {
    open: 'Visa {{name}} i full storlek',
    download: 'Ladda ner bilden',
    openInNewTab: 'Öppna i ny flik',
    close: 'Stäng',
  },
  citation: {
    source: 'Källa {{index}}',
    openDocument: 'Öppna dokumentet',
  },
  workspace: {
    browser: {
      title: 'Webbläsare',
      starting: 'Startar…',
      closed: 'Webbläsaren är stängd',
      closedHint: 'Be HUB att surfa någonstans så startar den igen.',
      info: {
        title: 'Om den delade webbläsaren',
        shared: 'Alla med tillgång till chatten kan se och styra webbläsaren medan den är igång.',
        cookies:
          'Inloggningar (cookies) tillhör den som startade sessionen — den som skrev senaste meddelandet eller tog över.',
        persist:
          'De sparas krypterat per användare och följer med till nästa session, i alla projekt.',
        clear: 'Rensa dina sparade inloggningar under Inställningar → Webbläsare.',
      },
      error: 'Fel',
      agentControls: 'HUB styr',
      userControls: 'Du styr',
      waitingForYou: 'HUB väntar på dig',
      takeControl: 'Ta över',
      takeControlHint: 'Pausar HUB så att du kan styra webbläsaren själv',
      handBack: 'Lämna tillbaka',
      handBackHint: 'Låt HUB fortsätta',
      close: 'Stäng webbläsaren',
      hint: 'Du kan klicka och skriva direkt i vyn. Tryck Lämna tillbaka (eller Done i vyn) när du är klar så fortsätter HUB.',
      expand: 'Förstora',
      collapse: 'Förminska',
    },
    title: 'Arbetsyta',
    close: 'Stäng arbetsytan',
    tasks: 'Uppgifter',
    documents: 'Dokument',
    sources: 'Källor',
    attachments: 'Bilagor',
    nothingYet: 'Inget ännu',
    document: 'dokument',
  },
  dev: {
    menu: 'Utvecklarmeny',
    nextReply: 'Nästa svar',
    normal: 'Normalt svar',
    modes: {
      provider_capability: { label: 'Capability-fel', hint: 'modellen avvisar — ej retry' },
      provider_transient: { label: 'Tillfälligt fel', hint: '429/timeout — retry' },
      hard_error: { label: 'Hårt fel', hint: 'agenten kraschar' },
      unknown: { label: 'Okänt fel', hint: 'oklassificerat' },
      tool_error: { label: 'Verktygsfel', hint: 'ett verktygsanrop misslyckas' },
    },
    note: 'Gäller nästa meddelande du skickar, sedan återställs läget. Bara synligt lokalt för superadmin.',
  },
  chats: {
    title: 'Alla chattar',
    count_one: '{{count}} chatt',
    count_other: '{{count}} chattar',
    searchPlaceholder: 'Sök chattar...',
    all: 'Alla',
    noMatch: 'Inga chattar matchar sökningen',
    empty: 'Inga chattar ännu',
    pinned: 'Fästa',
    recent: 'Senaste',
    untitled: 'Ny chatt',
    pin: 'Fäst',
    unpin: 'Avfäst',
    rename: 'Byt namn',
    delete: 'Ta bort',
    renameTitle: 'Byt namn på chatt',
    renameDescription: 'Ange ett nytt namn för chatten.',
    namePlaceholder: 'Chattnamn',
    cancel: 'Avbryt',
    save: 'Spara',
    saving: 'Sparar...',
    deleteTitle: 'Ta bort chatt',
    deleteDescription: 'Är du säker på att du vill ta bort "{{title}}"? Detta går inte att ångra.',
    deleting: 'Tar bort...',
    showArchived: 'Visa arkiverade',
    archived: 'Arkiverad',
    unarchive: 'Återställ',
  },
  credits: {
    exhaustedOrg:
      'Organisationens krediter är slut. Kontakta en administratör för att höja gränsen.',
    exhaustedProject: 'Projektets kreditgräns är nådd. Projektägaren kan höja eller ta bort taket.',
    exhaustedTts: 'Krediterna är slut – uppläsning är pausad.',
    exhaustedDictation: 'Krediterna är slut – diktering är pausad.',
  },
  collab: {
    unknownUser: 'Okänd',
  },
  // Board 5q82 — chat landing card while the project has no description.
  onboarding: {
    title: 'Kom igång med projektet',
    body: 'Berätta om projektet så blir HUB rätt kollega från start — några korta frågor om projektet, din roll och vad du vill ha hjälp med.',
    start: 'Starta',
    starting: 'Startar…',
    failed: 'Kunde inte starta samtalet. Försök igen.',
    bannerTitle: 'Projektstart',
    bannerBody:
      'Här sätter du upp projektet. HUB ställer några korta frågor om projektet, din roll och vad du vill ha hjälp med, och sparar svaren i projektinställningarna. Du kan hoppa över vilken fråga som helst – eller alltihop.',
    archivedNote: 'Chatten är arkiverad och syns inte i chattlistan.',
    unarchive: 'Återställ',
  },
}

export default chat
